import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.462 0 0 4.462 0 10s4.462 10 10 10 10-4.462 10-10S15.538 0 10 0Zm4.946 8.333-5.161 5.162c-.27.269-.592.376-.968.376s-.699-.107-.967-.376L5 10.645A1.363 1.363 0 0 1 5 8.71a1.363 1.363 0 0 1 1.936 0l1.882 1.882 4.247-4.247a1.363 1.363 0 0 1 1.935 0c.484.59.484 1.451-.054 1.989Z"
      fill="#00A692"
    />
  </svg>
)

export default SvgComponent